import React, { FC } from 'react';

import { Row, Col } from 'crehana-ui/GridV2';

import { COURSES_PER_PAGE, CUSTOM_GRID_GUTTER } from '../constants';

import SearchCourseCardSkeleton from './SearchCourseCardSkeleton';

type CourseListSkeletonProps = {
  isDark: boolean;
  count?: number;
};

const CourseListSkeleton: FC<CourseListSkeletonProps> = ({ isDark, count }) => (
  <Row gutter={CUSTOM_GRID_GUTTER}>
    {Array.from({ length: count || COURSES_PER_PAGE }).map((_, index) => (
      <Col
        key={`search-landing-course-skeleton-${index * 1}`}
        xs={12}
        sm={4}
        md={3}
        gutter={CUSTOM_GRID_GUTTER}
      >
        <SearchCourseCardSkeleton isDark={isDark} />
      </Col>
    ))}
  </Row>
);

export default CourseListSkeleton;
